import SentenceStudyListeningFillInTheBlankBase from 'es6/controllers/apps/quizzes/sentence-study-listening-fill-in-the-blank-base';

/**
 * Base class for the fill in the blank sentence quizzes.
 */
export class SentenceStudyListeningFillInTheBlank extends SentenceStudyListeningFillInTheBlankBase {
  constructor(...args) {
    super(...args);
    this._mode = 'full';
    this._setQuizType('SentenceStudyListeningFillInTheBlank');
  }
}

export default SentenceStudyListeningFillInTheBlank;
